import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';
import { UseFilterValuesType, UseOptionsQueryParams } from '@/components/FilterNew/types';
import { useDepartmentsQuery } from '@/modules/org-hierarchy/modules/departments/graphql/queries/generated/departments';

import useFilterOptionsQuery from '../../hooks/useFilterOptionsQuery';
import useFilterValue from '../../hooks/useFilterValue';
import { getDepartmentFilterOption } from './utils';

const edgeKey = 'departments';

const useOptionsQuery = ({ searchText }: UseOptionsQueryParams) =>
  useFilterOptionsQuery({
    useQuery: useDepartmentsQuery,
    edgeKey,
    variables: { filters: { name: searchText } },
    getFilterOption: getDepartmentFilterOption,
  });

const useFilterValues: UseFilterValuesType = ({ value }) =>
  useFilterValue({
    value,
    useQuery: useDepartmentsQuery,
    edgeKey,
    variables: { filters: { ids: value } },
    getFilterOption: getDepartmentFilterOption,
  });

export const DepartmentEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useFilterValues,
  useOptionsQuery,
};
